import React from 'react';
import { Box, Card, IconButton, CardContent, Typography } from '@mui/material';
import { CloseOutlined } from '@ant-design/icons';

const ContextMessage = ({ context, theme, onRemove }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-start',
      mb: 2
    }}
  >
    <Card
      sx={{
        maxWidth: '85%',
        background: `linear-gradient(135deg, ${theme.palette.info.light}, ${theme.palette.info.main})`,
        color: theme.palette.info.contrastText,
        borderRadius: '20px 20px 20px 4px',
        boxShadow: `0 2px 10px ${theme.palette.action.hover}`,
        border: `1px solid ${theme.palette.info.main}`,
        position: 'relative'
      }}
    >
      <IconButton
        onClick={() => onRemove(context.id)}
        sx={{
          position: 'absolute',
          top: 4,
          right: 4,
          color: theme.palette.info.contrastText,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          width: 20,
          height: 20,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)'
          }
        }}
      >
        <CloseOutlined style={{ fontSize: '12px' }} />
      </IconButton>
      <CardContent sx={{ p: 2, pr: 4, '&:last-child': { pb: 2 } }}>
        <Typography variant="caption" sx={{ opacity: 0.9, fontWeight: 'bold' }}>
          {context.selectionType === 'text' ? '📝 Text Selected' : '📋 Card Selected'}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, maxHeight: '100px', overflow: 'auto' }}>
          {context.content}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            opacity: 0.7,
            display: 'block',
            mt: 1,
            fontSize: '0.75rem'
          }}
        >
          {new Date(context.timestamp).toLocaleTimeString()}
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

export default ContextMessage;
